import React, { PropsWithChildren } from 'react';

export const Footer = ({ children }: Props) => {
    return (
        <>
            {children}
        </>
    );
};

type Props = PropsWithChildren<Record<never, never>>;